import { useMediaQuery, useTheme } from "@mui/material";

export const useNavTileScale = () => {
  const theme = useTheme();

  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const scale = isExtraSmallScreen
    ? 0.3
    : isSmallScreen
    ? 0.5
    : isMediumScreen
    ? 0.6
    : 1;

  return scale;
};
